import { useEffect, useState } from 'react';

/** True once the page has scrolled past `offset` pixels. */
export const useScrolled = (offset: number = 8) => {
    const [isScrolled, setIsScrolled] = useState<boolean>(false);

    useEffect(() => {
        const onScroll = () => setIsScrolled(window.scrollY > offset);

        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, [offset]);

    return isScrolled;
};
